import type {CSSProperties} from 'react';
import {weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeSearchOverlayLook = 'searchbar-leave' | 'searchbar-leave-card';

export const isWedgeSearchOverlayLook = (look: string): look is WedgeSearchOverlayLook => look === 'searchbar-leave' || look === 'searchbar-leave-card';

/* Released leading control of the search overlay bar (the close button, or the back button inside the Saved manager), off-scale. It is a
   bare inline flex box with no fill and no border, 10px padding round a 24px glyph, a 44px floor on both sides, 16px medium type and a
   pointer. `searchbar-leave` keeps the legacy accent ink text, so the shipped light accent ink rule, which matches `color: var(--accent);`
   in the serialized style, still reaches it; the declaration order is the source order for the same reason. `searchbar-leave-card` is the
   same box on the black camera surface and reads the --wedge-search-bar-ink role, which the caller sets to the light ink. It draws no transparent target (wedgeSearchOverlayDrawsHit): the 44px floor already makes the button box the target, so a 44px
   region would add nothing and would add a positioned box that legacy does not have. */
export const wedgeSearchOverlayDrawsHit = (look: string): boolean => !isWedgeSearchOverlayLook(look);

export function wedgeSearchOverlayStyle(look: WedgeSearchOverlayLook): CSSProperties {
  return {
    background: 'none', border: 0, color: look === 'searchbar-leave' ? wedgeExactRole('accent') : 'var(--wedge-search-bar-ink, inherit)',
    fontSize: 16, fontWeight: weight.medium, cursor: 'pointer', padding: 10,
    minWidth: 44, minHeight: 44,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  };
}
